import React from "react";
import Button from '@mui/material/Button';
import {  useNavigate } from 'react-router-dom';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import "./doctor.scss";
const DoctorInformation = (props) => {
    const getUserValue = JSON.parse(sessionStorage.getItem("loginDetails"))
    const intitalState = {
        doctorName: "",
            mobileNumber: "",
            address: "",
            registrationNumber: "",
            description: "",
            amount: null,
            activeStatus: true,
            CreatedBy: getUserValue?.uniqueID
    }
   
    const navigate = useNavigate();
    const { submitDoctorInfo } = props
    const [doctorInfoInputFields, setdoctorInfoInputFields] = React.useState(intitalState);

    const handleDoctorhInfoInputChange = (event) => {
        const { name, value } = event.target;
        setdoctorInfoInputFields((prevState) => {
            return {
                ...prevState,
                [name]: value,
            };
        });
    }
    const handleGoBack = () => {
        navigate("/master/doctor", { state: { addPatient: false, rowData: {} } })
    }
   const handleDoctor = (event, doctorInfoInputFields) => {
    submitDoctorInfo(event, doctorInfoInputFields)
    setdoctorInfoInputFields(intitalState)
   }
    return (
        <>
            
            <form>
                <div className="doctor-info" >
                    <div className="mt-2 ml-4">
                        <h4>Doctor Information</h4>
                        <div className="back-btn" onClick={handleGoBack}>
                            <ArrowBackIcon className="arrow-color" />
                            <span
                                style={{ cursor: "pointer" }}
                                className="anchr-link header-text mt-3 mb-3"
                            >
                                {"Back"}
                            </span>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="form-group col-md-6">
                            <label for="fname" className="control-label col-sm">Doctor Name*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i className="fas fa-user-md"></i></div>
                                    </div>
                                    <input type="text"
                                        className="form-control"
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        placeholder="Doctor Name" name="doctorName" 
                                        value={doctorInfoInputFields?.doctorName} 
                                        onChange={handleDoctorhInfoInputChange} required />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Mobile Number*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i className="fa fa-mobile" aria-hidden="true"></i></div>
                                    </div>
                                    <input
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        type="text" className="form-control" 
                                        placeholder="Mobile Number" name='mobileNumber' 
                                        value={doctorInfoInputFields?.mobileNumber} 
                                        onChange={handleDoctorhInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Address*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i className="fa fa-address-card" aria-hidden="true"></i></div>
                                    </div>
                                    <input
                                        type="text" 
                                        className="form-control" id="lname" 
                                        placeholder="Address" name="address" 
                                        value={doctorInfoInputFields?.address} 
                                        onChange={handleDoctorhInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Registration Number*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i className="fa fa-registered" aria-hidden="true"></i></div>
                                    </div>
                                    <input
                                        type="text" 
                                        className="form-control" id="registrationNumber" 
                                        placeholder="Registration Number" name="registrationNumber" 
                                        value={doctorInfoInputFields?.registrationNumber} 
                                        onChange={handleDoctorhInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Amount</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><CurrencyRupeeIcon /></div>
                                    </div>
                                    <input
                                        type="text" className="form-control" id="amount" 
                                        placeholder="Amount" name="amount" 
                                        min="0"
                                        value={doctorInfoInputFields?.amount} onChange={handleDoctorhInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Description*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i className="fas fa-info"></i></div>
                                    </div>
                                    <input
                                        type="text" 
                                        className="form-control" 
                                        id="lname" 
                                        placeholder="Description" 
                                        name="description" 
                                        value={doctorInfoInputFields?.description} 
                                        onChange={handleDoctorhInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
                <div className="d-flex justify-content-end mr-3 mb-3">
                    <Button variant="outlined" className="mr-2" onClick={(event) => handleDoctor(event, doctorInfoInputFields)}>Add Doctor</Button>
                </div>
            </form>
        </>
    );
};

export default DoctorInformation; 